import type { Theme } from "@mui/material"
import { createGlobalNavigationItemTheme } from "./components/GlobalNavigationItem"
import { CustomThemeCreator } from "../../types"
import { createSimpleWidgetCardTheme } from "./components/SimpleWidgetCard"

export const createTheme: CustomThemeCreator = (theme: Theme) => ({
    GlobalNavigationItem: createGlobalNavigationItemTheme(theme),
    SimpleWidgetCard: createSimpleWidgetCardTheme(theme),
})
